var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"isAuthenticated":_vm.isAuthenticated}}),_c('div',{staticClass:"body-container"},[(_vm.isAuthenticated || _vm.isSSO)?_c('div',[(_vm.userIsLoaded || _vm.isSSO)?_c('router-view'):_c('b-spinner',{attrs:{"variant":"primary"}})],1):_c('div',[_c('Login')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }